import { BlockApi } from "../../../../Shared/Constants/api";

import axiosInstance from "../../../../Shared/Utils/axiosInstance";

import { getBlockCreationObject } from "../Data/BlockWrappers";

export const updateBlockApi = async (data, id) => {
  try {
    let response = await axiosInstance.put(
      `${BlockApi}/${id}`,
      getBlockCreationObject(data)
    );

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further Block if needed
  }
};
